<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex lg8 md8 sm12 xs12>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card>
                  <v-card-text class="pa-4 enr-course-description">
                    <span style="white-space: break-spaces">{{ course.short_description }}</span>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs12>
                <v-card>
                  <v-card-text class="pa-4 mt-2 mb-2 enr-course-description">
                    <div v-if="course.description && course.description.length > 500">
                      <span style="white-space: break-spaces" v-if="!readMoreActivated"
                        >{{ course.description.slice(0, 500) + "... " }}
                      </span>
                      <a class="" v-if="!readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                        >{{ $t("global.show_more") }}...</a
                      >

                      <span style="white-space: break-spaces" v-if="readMoreActivated">{{ course.description }} </span>
                      <a class="" v-if="readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                        >{{ $t("global.show_less") }}...</a
                      >
                    </div>
                    <div v-if="course.description && course.description.length <= 500">
                      <span style="white-space: break-spaces">{{ course.description }} </span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-card>
              <v-card-text class="pa-4">
                <v-layout row wrap>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.first_name"
                      v-model="enrolment.first_name"
                      :label="$t('enrolments.p_first_name')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.last_name"
                      v-model="enrolment.last_name"
                      :label="$t('enrolments.p_last_name')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.email"
                      v-model="enrolment.email"
                      :label="$t('enrolments.p_email')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.mobile"
                      v-model="enrolment.mobile"
                      :label="$t('enrolments.p_mobile')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.date_of_birth"
                      :value="computedDateofBirth"
                      :label="$t('enrolments.p_date_of_birth')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.reference"
                      v-model="enrolment.reference"
                      :label="$t('enrolments.o_reference')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.course"
                      v-model="course.name"
                      :label="$t('enrolments.course')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                      name="enrolments.comment"
                      v-model="enrolment.comments"
                      :label="$t('enrolments.comment')"
                      no-resize
                      readonly
                    ></v-textarea>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>

            <v-card class="mt-4">
              <v-app-bar dense text color="secondary">
                <v-toolbar-title class="subheading">{{ $t("enrolments.address_title") }}</v-toolbar-title>
              </v-app-bar>
              <v-card-text class="pa-4">
                <v-layout row wrap>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.street"
                      v-model="enrolment.street"
                      :label="$t('enrolments.p_address_street')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg1 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.zip"
                      v-model="enrolment.zip"
                      :label="$t('enrolments.p_address_zip')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg2 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.city"
                      v-model="enrolment.city"
                      :label="$t('enrolments.p_address_city')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg3 md4 sm6 xs12>
                    <v-text-field
                      name="enrolment.country"
                      :value="enrolment.country ? this.$dd_countries(enrolment.country) : ''"
                      :label="$t('enrolments.p_address_country')"
                      readonly
                      autocomplete="new-password"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <enrolmentDetails :key="reRenderEnrolmentDetails" :id="Number(enrolment.id)" :token="token" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import enrolmentDetails from "@/modules/enrolments/partials/EnrolmentDetails.vue"

export default {
  name: "EnrolmentView",

  components: {
    enrolmentDetails
  },

  props: ["id", "locale", "token"],

  data() {
    return {
      page_title: "",
      predata: {},
      enrolment: {},
      course: {},
      reRenderEnrolmentDetails: 0,
      readMoreActivated: false
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.enrolment, this.predata, this.save, this.isFormValid)
    })
  },

  created() {
    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .get(this.API_URL + "open/enrolment/" + this.id + "/" + this.token)
      .then((res) => {
        this.enrolment = res.data.data
        this.course = this.enrolment.course
        this.page_title =
          this.$t("fe.enrolment.enrolment_to") +
          " " +
          this.course.name +
          ", " +
          this.$dateFormatGetter(this.course.start_date) +
          " " +
          this.$timeFormatGetter(this.course.start_time) +
          " - " +
          this.$dateFormatGetter(this.course.end_date) +
          " " +
          this.$timeFormatGetter(this.course.end_time)

        this.reRenderEnrolmentDetails++

        // JSON stringify and parse to remove variable reactiveness
        this.predata = JSON.parse(JSON.stringify(this.enrolment))
      })
      .catch((err) => console.log(err))
  },

  computed: {
    computedDateofBirth() {
      return this.enrolment.date_of_birth ? this.moment.utc(this.enrolment.date_of_birth).format(this.DATE_FORMAT) : ""
    }
  }
}
</script>

<style scoped></style>
